import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom'

import { describeError } from '@/api/errors'
import { Button } from '@/shared/ui/Button'

/**
 * Cosa si vede quando una rotta va in errore.
 *
 * Dice cosa è successo e offre la via d'uscita più probabile. Non si scusa e
 * non mostra lo stack: chi legge non può farci niente.
 */
export function RouteError() {
  const error = useRouteError()
  const navigate = useNavigate()

  const message = isRouteErrorResponse(error)
    ? `${error.status} · ${error.statusText}`
    : describeError(error)

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 p-8 text-center">
      <p className="type-eyebrow">Questa pagina si è fermata</p>
      <h1 className="type-display max-w-lg">{message}</h1>
      <div className="mt-2 flex gap-2">
        <Button variant="secondary" onClick={() => void navigate(-1)}>
          Torna indietro
        </Button>
        <Button variant="primary" onClick={() => void navigate('/ricerca', { replace: true })}>
          Vai a Ricerca
        </Button>
      </div>
    </div>
  )
}

export function NotFound() {
  const navigate = useNavigate()

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-8 text-center">
      <p className="type-eyebrow">Indirizzo sconosciuto</p>
      <h1 className="type-display max-w-lg">Questa pagina non esiste nella dashboard.</h1>
      <p className="text-thread-400 text-sm max-w-sm">
        Può essere un collegamento vecchio, o un modulo rinominato. La navigazione a sinistra porta
        a tutto quello che c'è.
      </p>
      <Button variant="primary" className="mt-2" onClick={() => void navigate('/ricerca')}>
        Vai a Ricerca
      </Button>
    </div>
  )
}
